import { environment } from 'src/environments/environment';

export const sentryConfig = {
  dsn: 'https://0ae3157b263c43f79d2290d48689447c@o385044.ingest.sentry.io/5644654',
  release: 'cleanfill@' + environment.version,
  environment: environment.env,
  ignoreErrors: [
    /AADSTS50058: A silent sign-in request was sent but no user is signed in.*/,
    /AADSTS50058: A silent sign-in request was sent but none of the currently signed in user[(]s[)] match the requested login hint.*/,
    /AADB2C90077: User does not have an existing session and request prompt parameter has a value of \'None\'.*/,
    /ClientAuthError: User login is required.*/,
    /ClientAuthError: URL navigated to is */,
    /User login is required.*/
  ]
};
